import { render, staticRenderFns } from "./PhenologicalTrackingDetails.vue?vue&type=template&id=60f48752&scoped=true&lang=html&"
import script from "./PhenologicalTrackingDetails.vue?vue&type=script&lang=js&"
export * from "./PhenologicalTrackingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f48752",
  null
  
)

export default component.exports